export default __webpack_public_path__ + "static/media/user-arrow.0d9e29a9.svg";